import { render, staticRenderFns } from "./ProfileBasicEditor.vue?vue&type=template&id=6a37084a&scoped=true"
import script from "./ProfileBasicEditor.vue?vue&type=script&lang=ts&setup=true"
export * from "./ProfileBasicEditor.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./ProfileBasicEditor.vue?vue&type=style&index=0&id=6a37084a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a37084a",
  null
  
)

export default component.exports